// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
  width: 80%;
  margin-top: 50px;
}

.top-buffer {
  margin-top: 6px;
}

.read {
  color: black;
  /* transition: background-color 2s ease-out; */
}

.unread {
  background-color: #76d0f5;
  /* background-color:red; */
  color: black;
}

.orderlink {
  border-bottom: solid 1px cadetblue;
  display: inline;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-flex > .mat-form-field-infix {
  padding: 0.4em 0px !important;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-label-wrapper {
  top: -1.5em;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

table th {
  background-color: rgb(238, 70, 81);
  color: white;
}

table, th:first-child {
  border-top-left-radius: 10px;
}

table, th:last-child {
  border-top-right-radius: 10px;
}

table {
  background-color: var(--primary-grey-light);
}

.mat-elevation-z2 {
  border-radius: 10px;
}

.paginator {
  background-color: var(--primary-grey-light);
  border-bottom-left-radius: var(--def-padding);
  border-bottom-right-radius: var(--def-padding);
}

::ng-deep .hide-arrow .mat-sort-header-arrow {
  color: #fff;
}

.paginator {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/messages/messages.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACI,UAAA;EACA,gBAAA;AADJ;;AAIA;EAAc,eAAA;AAAd;;AAEA;EACI,YAAA;EACA,8CAAA;AACJ;;AACA;EACI,yBCHW;EDIX,0BAAA;EACA,YAAA;AAEJ;;AAAA;EACI,kCAAA;EACA,eAAA;AAGJ;;AAAE,iIAAA;AACA;EAAyD,6BAAA;AAI3D;;AAHE,iIAAA;AACA;EAA0C,WAAA;AAO5C;;AALE,iIAAA;AACA;EACI,yCAAA;EACA,iBAAA;AAQN;;AALE;EACE,kCC7BY;ED8BZ,YChCa;ADwCjB;;AALA;EACI,4BAAA;AAQJ;;AALI;EACI,6BAAA;AAQR;;AALI;EACI,2CAAA;AAQR;;AANI;EACI,mBAAA;AASR;;AAPI;EACI,2CAAA;EACA,6CAAA;EACA,8CAAA;AAUR;;AAPI;EACI,WAAA;AAUR;;AAPI;EACI,aAAA;EACA,yBAAA;EACA,aAAA;AAUR","sourcesContent":["@import '../../../scss/variables';\n\n.modal-dialog {\n    width: 80%;\n    margin-top: 50px;\n}\n\n.top-buffer { margin-top: 6px;}\n\n.read{    \n    color:black;\n    /* transition: background-color 2s ease-out; */\n}\n.unread{    \n    background-color: $accept-color;\n    /* background-color:red; */\n    color:black;\n}\n.orderlink{\n    border-bottom: solid 1px cadetblue;\n    display: inline;\n  }\n\n  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n  ::ng-deep .mat-form-field-flex > .mat-form-field-infix { padding: 0.4em 0px !important;}\n  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n  ::ng-deep .mat-form-field-label-wrapper { top: -1.5em; }\n  \n  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n  ::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n      transform: translateY(-1.1em) scale(.75);\n      width: 133.33333%;\n  }\n\n  table th{\n    background-color: $primary-color;\n    color: $selected-metal;\n}\n\ntable, th:first-child{ \n    border-top-left-radius: 10px;    \n    }\n    \n    table,th:last-child{\n        border-top-right-radius: 10px;   \n    }\n    \n    table{\n        background-color: var(--primary-grey-light);\n    }\n    .mat-elevation-z2{\n        border-radius: 10px;\n    }\n    .paginator{\n        background-color: var(--primary-grey-light);\n        border-bottom-left-radius: var(--def-padding);\n        border-bottom-right-radius: var(--def-padding);\n    }\n\n    ::ng-deep .hide-arrow .mat-sort-header-arrow {\n        color: #fff;\n    }\n\n    .paginator{\n        display: flex;\n        justify-content: flex-end;\n        padding: 15px;\n    }","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
